var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilePdf1 = function SvgFilePdf1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".file-pdf-1_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    x: 0.5,
    y: 0.499,
    className: "file-pdf-1_svg__a",
    rx: 1,
    ry: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.5a2 2 0 0 1-2 2h-2v-4h2a2 2 0 0 1 2 2M4.5 19.499v-4M10.5 11.5a4 4 0 1 1 0 8ZM16.5 19.5V13a1.5 1.5 0 0 1 1.5-1.5h2.5M16.5 15.499H19",
    className: "file-pdf-1_svg__a"
  })));
};
export default SvgFilePdf1;